// ICSP-59: provider for the AdultGate presentation flag (see
// adultGateContext.ts for the rationale). Kept in its own file so it is the
// only export — react-refresh/only-export-components stays happy.

import { useMemo, useState, type ReactNode } from "react";

import { AdultGateContext } from "./adultGateContext";

export function AdultGateProvider({ children }: { children: ReactNode }) {
  const [gated, setGated] = useState(false);
  const value = useMemo(() => ({ gated, setGated }), [gated]);
  return (
    <AdultGateContext.Provider value={value}>
      {children}
    </AdultGateContext.Provider>
  );
}
